// extracted by mini-css-extract-plugin
module.exports = {"SECTION":"section-module--SECTION--MN5kH"};